<template>
  <div class="row">
    <alert-comp :key="alert.key" :msg="alert" />
    <label for="" class="col-sm-12 text-left">Observação:<span class="text-danger">*</span></label>
    <div class="col-sm-12">
      <div class="form-group input-group" :class="{
        'form-group--error': $v.observacao.$error
      }">
        <textarea
          class="form-control"
          rows="3"
          v-model.trim="$v.observacao.$model"
        />
      </div>
      <div class="error" v-if="!$v.observacao.required">O campo é obrigatório</div>
    </div>
    <div class="modal-body text-md-right text-sm-center">
      <button type="button" class="btn btn-outline-primary m-1" @click.prevent="salvar()">Salvar</button>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import alertComp from '@/components/alert/AlertComp'

import VirtusMensagemService from '@/services/VirtusMensagemService'

import eventBus from '@/uteis/eventBus'

import md5 from 'md5'

export default {
  name: 'salvar-observacao',

  components: {
    alertComp
  },

  props: {
    numeroProcesso: { type: String, required: true },
    eventBusModal: { type: String, required: true }
  },

  validations: {
    observacao: {
      required
    }
  },

  data () {
    return {
      observacao: '',
      alert: {
        type: '',
        texto: '',
        key: true
      }
    }
  },

  computed: {
    securityKey () {
      const dateNow = new Date()
      const observacao = this.observacao
      return md5(dateNow + observacao)
    }
  },

  methods: {
    salvar () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      const dadosSessao = this.$store.getters.getDadosSessao.sessao

      var destinos = [{
        titulo: this.numeroProcesso,
        identificador: this.numeroProcesso,
        tipoIdentificador: 'NUMERO_PROCESSO',
        participantePai: {
          titulo: dadosSessao.descricaoDepartamento,
          subtitulo: dadosSessao.siglaDepartamento,
          identificador: dadosSessao.idDepartamento.toString(),
          tipoIdentificador: 'ID',
          participantePai: {
            titulo: dadosSessao.descricaoOrgao,
            subtitulo: dadosSessao.siglaOrgao,
            identificador: dadosSessao.idOrgao.toString(),
            tipoIdentificador: 'ID'
          }
        }
      }]

      const executor = {
        titulo: dadosSessao.nomeUsuario,
        identificador: dadosSessao.login,
        tipoIdentificador: 'LOGIN',
        participantePai: {
          titulo: dadosSessao.descricaoDepartamento,
          subtitulo: dadosSessao.siglaDepartamento,
          identificador: dadosSessao.idDepartamento.toString(),
          tipoIdentificador: 'ID',
          participantePai: {
            titulo: dadosSessao.descricaoOrgao,
            subtitulo: dadosSessao.siglaOrgao,
            identificador: dadosSessao.idOrgao.toString(),
            tipoIdentificador: 'ID'
          }
        }
      }

      var body = {
        destino: destinos,
        executor,
        titulo: 'Observação',
        texto: this.observacao
      }

      this.service.createMensagem(body, this.securityKey).then(res => {
        this.updateAlert('success', 'Observação criada com sucesso. Daqui a dois segundos você será redirecionado para a lista de observações')
        setTimeout(() => {
          eventBus.$emit(this.eventBusModal)
        }, 2000)
      }).catch(err => {
        this.alert.texto = !err.response.data || !err.response.data.message ? 'Aconteceu algo com servidor.' : err.response.data.message
        this.alert.type = 'danger'
      })
    },

    updateAlert (type, menssage) {
      this.alert = {
        type: type,
        texto: menssage,
        key: !this.alert.key
      }
    }
  },

  created () {
    this.service = new VirtusMensagemService()
  }
}
</script>
